"use client";
import {Button, Form, Input} from "antd";
import {useUserStore} from "@/lib/store/user.store";
import {memo, useState} from "react";
import {useUserInfo} from "@/hooks/useUserInfo";

type FieldType = {
    realname: string;
    nickname: string;
    email: string;
};
export default memo(function PersonalData() {
    const [loading, setLoading] = useState(false);
    const {uploadMemberInfo} = useUserInfo();
    const onFinish = (values: FieldType) => {
        uploadMemberInfo({
            setLoading,
            member: {
                ...values
            }
        });
    };
    return <div className="py-16">
        <Form
            name="basic"
            className="!grid !grid-cols-2"
            labelCol={{span: 5}}
            wrapperCol={{span: 16}}
            initialValues={{
                realname: useUserStore.getState()?.userInfo?.member?.realname,
                nickname: useUserStore.getState()?.userInfo?.member?.nickname,
                email: useUserStore.getState()?.userInfo?.member?.email
            }}
            onFinish={onFinish}
            autoComplete="off"
        >
            <Form.Item<FieldType>
                label="姓名"
                name="realname"
                rules={[{required: true, message: "姓名不能为空"}]}
            >
                <Input placeholder="请输入姓名"/>
            </Form.Item>

            <Form.Item<FieldType>
                label="用户名"
                name="nickname"
                rules={[{required: true, message: "昵称不能为空"}]}
            >
                <Input placeholder="请输入昵称"/>
            </Form.Item>

            <Form.Item<FieldType>
                label="邮箱"
                name="email"
                required={true}
                rules={[{
                    validator: (rule: any, value: string) => {
                        if (!value) {
                            return Promise.reject("邮箱不能为空");
                        }
                        if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
                            return Promise.reject("邮箱格式不正确");
                        }
                        return Promise.resolve();
                    }
                }]}
            >
                <Input placeholder="请输入邮箱"/>
            </Form.Item>

            <Form.Item className="!col-span-2 c-flex !mt-2">
                <Button type="primary" htmlType="submit" className="!px-16" loading={loading}>
                    保存
                </Button>
            </Form.Item>
        </Form>
    </div>;
});
